import { Box, Modal, Typography } from "@mui/material";
import PropTypes from "prop-types";
import LoginForm from "../LoginForm/LoginForm";
import { authModalStore } from "../../context/authModalStore";
import { Link } from "react-router-dom";

export default function AuthModal() {
  const { open, handleClose } = authModalStore();
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-auth"
      aria-describedby="modal-auth"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          color: "primary.contrastText",
        }}
      >
        <Typography align="center" color="text.primary" variant="h4">
          Inicia Sesión
        </Typography>
        <LoginForm colorScheme="black" />
      </Box>
    </Modal>
  );
}

AuthModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
